// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.no-label-pro .label-pro {
    display: none !important;
}
.header-nav-item.user-profile .avatar[data-noclip='true'], .header-nav-item.user-profile .avatar[src\$='-pmpr.png'], .header-nav-item.user-profile .avatar[src\$='-pmfr.png'], .header-nav-item.user-profile .avatar[src\$='-pmth.png'] {
    border-radius: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/top-header-bar.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;AAC5B;AACA;IAII,2BAA2B;AAC/B","sourcesContent":[":global body.no-label-pro .label-pro {\n    display: none !important;\n}\n:global .header-nav-item.user-profile .avatar[data-noclip='true'],\n:global .header-nav-item.user-profile .avatar[src$='-pmpr.png'],\n:global .header-nav-item.user-profile .avatar[src$='-pmfr.png'],\n:global .header-nav-item.user-profile .avatar[src$='-pmth.png'] {\n    border-radius: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"no-label-pro": `no-label-pro`,
	"label-pro": `label-pro`,
	"header-nav-item": `header-nav-item`,
	"user-profile": `user-profile`,
	"avatar": `avatar`
};
export default ___CSS_LOADER_EXPORT___;
